import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Card,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Button,
  CardContent,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import "./TotalExamList.scss"; // Import SCSS styles
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { clearListExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import { listUserExamList } from "../../Redux/Slices/UserPackage/ListUserExamListSlice";
import { listInstructionExamID } from "../../Redux/Slices/Exam/ListinstructionExamIDSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { listUserPackage } from "../../Redux/Slices/UserPackage/ListUserPackageSlice";
import { AddSubscription } from "../../Redux/Slices/Subscription/AddSubscriptionSlice";
import Practiceexamimage3 from "../Practicepage/ImagePracticepage/Practice2.png";
import Practiceexamimage1 from "../Practicepage/ImagePracticepage/practice3.png";
import Practiceexamimage2 from "../Practicepage/ImagePracticepage/practice1.png";
import Practiceexamimage4 from "../Practicepage/ImagePracticepage/Preactice4.png";
import styles from "../Practicepage/PracticeTestGrid.module.scss";
import {
  clearDeleteSubscriptionResponse,
  deleteSubscription,
} from "../../Redux/Slices/Subscription/DeleteSubscriptionSlice";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import ButtonField from "../../Components/Button/ButtonField";
import Snackbar from "../../Components/Snackbar/Snackbar";
import {
  clearListSubscription,
  listSubscription,
} from "../../Redux/Slices/Subscription/ListSubscriptionSlice";
import {
  clearDashboardChart,
  dashboardChart,
} from "../../Redux/Slices/DashboardChart/DashboardChart";
import Menus from "../../Components/Menu/Menu";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
import WarningIcon from "@mui/icons-material/Warning";

const TotalExamList = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { data: listUserExamListSlice } = useAppSelector(
    (state) => state.ListUserExamListSlice
  );

  const { data: listUserPackageSlice } = useAppSelector(
    (state) => state.ListUserPackageSlice
  );
  const images = [
    Practiceexamimage1,
    Practiceexamimage3,
    Practiceexamimage2,
    Practiceexamimage4,
  ];
  const Packages = Array.isArray(listUserPackageSlice?.data)
    ? listUserPackageSlice?.data.map((user, index) => ({
        ...user,
        index: index + 1,
        image: images[index % images.length], // Assign images in a repeating pattern
      }))
    : [];
  // const Package = Array.isArray(listUserExamListSlice?.data)
  //   ? listUserExamListSlice?.data
  //       .filter((user) => !user.expired) // Filter out courses where expiry is false
  //       .map((user, index) => ({
  //         ...user,
  //         index: index + 1,
  //       }))
  //   : [];
  const DeleteSliceLoading = useAppSelector(
    (state) => state.DeleteSubscription
  );
  const [selectedPackage, setSelectedPackage] = useState<any>(null);

  useEffect(() => {
    dispatch(dashboardChart());
    dispatch(clearListSubscription());
    dispatch(listUserPackage());
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, [dispatch, DeleteSliceLoading]);

  const [details, setDetails] = useState<ILoginResponse>({});

  const [openPackageExam, setOpenPackageExam] = useState(false); // Step 3

  const { data: SubscriptionSlice, isLoading: scriptionSlice } = useAppSelector(
    (state) => state.ListSubscriptionSlice
  );
  const Subcriptiondetails: any = SubscriptionSlice;
  console.log(scriptionSlice, "loadingg");

  const [opensubscriptionExam, setOpensubscriptionExam] = useState(false);

  useEffect(() => {
    if (Subcriptiondetails?.status === false && selectedPackage) {
      setOpensubscriptionExam(true);
    }

    if (Subcriptiondetails?.status === true) {
      setOpensubscriptionExam(false);
    }
  }, [Subcriptiondetails, selectedPackage]);

  useLayoutEffect(() => {
    if (Subcriptiondetails?.status === true) {
      navigate("/subscribedPages");
    }
  }, [Subcriptiondetails]);

  const PackageId = sessionStorage.getItem("packageid");

  useEffect(() => {
    dispatch(clearDeleteSubscriptionResponse());
  }, [dispatch]);

  useEffect(() => {
    dispatch(listUser());
  }, [dispatch]);
  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];
  return (
    <>
      {DeleteSliceLoading?.data?.message && (
        <Snackbar response={DeleteSliceLoading?.data} />
      )}
      <div className="TotalStudentAlingment">
        {/* <div className="DashboardStudent">My Enrollments</div> */}
        <div className="TotalExamListmain">
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div className="courseslist">Enrolled Courses</div>
          </div> */}
          {/* {Package?.length === 0 ? (
            <>
              <div style={{ marginBottom: "20px" }}>
                <div className="customCardpending">
                  <Card
                    className="coures_cardspending"
                    sx={{ bgcolor: "#f5f5f5" }}
                  >
                    <Typography
                      className="heading_name"
                      sx={{ fontSize: "20px" }}
                      variant="h6"
                    >
                      Courses Not Available
                    </Typography>
                  </Card>
                </div>
              </div>
            </>
          ) : (
            Package?.map((pkg, index) => (
              <div key={index}>
                <div style={{ marginBottom: "20px", cursor: "pointer" }}>
                  <div className="customCardpendingtotal">
                    <div
                      className="coures_cardspending"
                      style={{ alignItems: "flex-start", borderRadius: "10px" }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ textAlign: "left", margin: "10px 0px" }}
                      >
                        {pkg?.course_name}
                      </Typography>

                      <Typography variant="body2" className="textsytle">
                        {pkg?.course_description}
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{ textAlign: "left", margin: "10px 0px" }}
                      >
                        {pkg?.exams?.length === 0
                          ? "Exams Not Available"
                          : "Exams List"}
                      </Typography>
                      {pkg?.exams?.map((listexam, examIndex) => (
                        <Accordion key={examIndex} sx={{ width: "100%" }}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id={`panel-${index}-header`}
                            sx={{
                              color: "#0088ff",
                            }}
                          >
                            {listexam?.exam_name}
                          </AccordionSummary>
                          <AccordionDetails>
                            <div>{listexam?.exam_description}</div>
                            <br></br>
                            <div className="Buttonlist">
                              <button
                                className="card-buttonexam"
                                onClick={() => {
                                  navigate("/examresult", {
                                    state: listexam?.student_exam_id,
                                  });
                                }}
                              >
                                View Report
                              </button>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))
          )} */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div className="courseslist">Packages on Everest Tutoring</div>

            <div>
              <Menus
                menuItems={[
                  // {
                  //   menu: "Profile",
                  //   onClick: () => {
                  //     nav("/studentprofile");
                  //   },
                  // },
                  {
                    menu: "Logout",
                    onClick: () => {
                      sessionStorage.clear();
                      dispatch(clearListuser());
                      dispatch(clearLoginStatus());
                      dispatch(clearDashboardChart());
                      navigate("/login");
                    },
                  },
                ]}
              >
                <IconButtonField onClick={() => {}}>
                  <Avatars sx={{ height: "2rem", width: "2rem" }} />
                </IconButtonField>
              </Menus>
              <span className="Username">{ListUser[0]?.student_name}</span>
            </div>
          </div>
          <Grid container spacing={3} className="practice-test-card">
            {Packages?.length === 0 ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Card className={styles.card} sx={{ boxShadow: "none" }}>
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <img
                      src={Practiceexamimage3}
                      alt="Mock Exam"
                      style={{
                        width: "100%",
                        height: "97%",
                        borderRadius: "10px 10px 0px 0px",
                      }} // Adjust size as needed
                    />
                  </div>

                  <CardContent className={styles.cardBody}>
                    <div className={styles.mockexamname}>
                      No Packages Available
                    </div>
                    <Typography
                      variant="body2"
                      className={styles.mockexamndescription}
                    >
                      Currently, there are no Packages available at the moment.
                      Please check back soon for updates and new Packages
                    </Typography>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        variant="contained"
                        className={styles.startButton}
                        onClick={() => {
                          navigate("/dashboard");
                        }}
                      >
                        Back to home
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              // Render this when the Package array has data
              Packages?.map((pkg: any, index) => (
                <>
                  <Grid item xs={12} sm={12} md={6} lg={3} key={index}>
                    <Card className={styles.card} sx={{ boxShadow: "none" }}>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          height: "175px",
                        }}
                      >
                        <img
                          src={pkg?.image}
                          alt="Mock Exam"
                          style={{
                            width: "100%",
                            height: "97%",
                            borderRadius: "10px 10px 0px 0px",
                          }} // Adjust size as needed
                        />
                      </div>

                      <CardContent className={styles.cardBody}>
                        <div className={styles.mockexamname}>
                          {pkg?.package_name}{" "}
                        </div>
                        <Typography
                          variant="body2"
                          className={styles.mockexamndescription}
                          sx={{ minHeight: "3em !important" }}
                        >
                          <p
                            style={{
                              minWidth: 0,
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              overflowWrap: "anywhere",
                              fontSize: "14px",
                              margin: "0",
                            }}
                          >
                            Total Course : {pkg?.course_count}
                          </p>
                        </Typography>

                        <span title={pkg?.description}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "12px",
                              display: "-webkit-box",
                              WebkitLineClamp: 4 /* Corrected vendor prefix */,
                              WebkitBoxOrient:
                                "vertical" /* Corrected vendor prefix */,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              textAlign: "justify",
                              minHeight:
                                "6rem" /* Adjusted minHeight for better readability with 4 lines */,
                            }}
                          >
                            {pkg?.description}
                          </Typography>
                        </span>

                        <div
                          style={{
                            width: "100%",
                          }}
                        >
                          {scriptionSlice === true ? (
                            <Button
                              variant="contained"
                              className="startButtonsubscribed"
                            >
                              Loading...
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              className="startButtonsubscribed"
                              onClick={() => {
                                dispatch(clearListSubscription());
                                if (pkg?.subscribed === true) {
                                  setOpenPackageExam(true);
                                  sessionStorage.setItem(
                                    "packageid",
                                    pkg?.stripe_subscription_id
                                  );
                                } else {
                                  // Replace with your target route
                                  dispatch(AddSubscription());
                                  dispatch(
                                    listSubscription({
                                      package_id: pkg?.package_id,
                                    })
                                  );
                                }
                              }}
                            >
                              {pkg?.subscribed === true
                                ? "Cancel Subscription"
                                : "Subscribe & Pay"}
                            </Button>
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                </>
              ))
            )}
          </Grid>
        </div>
      </div>

      <React.Fragment>
        <Dialog
          open={openPackageExam}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontSize: "15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: "10px",
                fontWeight: "500",
              }}
            >
              Are you sure you want to cancel your subscription?
            </DialogContentText>
            <DialogContentText
              sx={{
                fontSize: "12px",
                color: "warning.main",
                mt: 1,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <WarningIcon sx={{ fontSize: "18px", mt: "1px" }} />
              If you cancel your subscription, your premium features will no
              longer be available.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "center", gap: "20px" }}
          >
            <ButtonField
              className="form_save_button"
              onClick={() => {
                dispatch(deleteSubscription(PackageId));
                setOpenPackageExam(false);
              }}
            >
              Yes
            </ButtonField>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setOpenPackageExam(false);
              }}
            >
              No
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <React.Fragment>
        <Dialog
          open={opensubscriptionExam}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "30rem",
            }}
          >
            <ReportGmailerrorredIcon
              sx={{ fontSize: "50px", color: "#009dff" }}
            />
            <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px", textAlign: "center" }}
            >
              {Subcriptiondetails?.status === false
                ? "Your subscription is inactive."
                : "Processing your subscription..."}
            </DialogContentText>
          </DialogContent>

          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_cancel_buttonsub"
              onClick={() => setOpensubscriptionExam(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_buttonssub"
              onClick={() => {
                if (selectedPackage) {
                  dispatch(AddSubscription());
                  dispatch(
                    listSubscription({
                      package_id: selectedPackage.package_id,
                    })
                  );
                }
                setOpensubscriptionExam(false);
              }}
            >
              {Subcriptiondetails?.status === true
                ? "Loading..."
                : "Continue to Payment"}
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  );
};

export default TotalExamList;
